import Image from 'next/image';

import type { JSX, ReactNode } from 'react';

import { cn } from '~/utils';
import { Skeleton } from '~/components/skeleton';
import { HStack, Stack } from '~/components/stack';

interface IThumbnailSectionProps {
  alt?: string;
  thumbnail?: string;
  children: ReactNode;
  contentClassName?: string;
}

export function ThumbnailSection({
  alt,
  children,
  thumbnail,
  contentClassName,
}: IThumbnailSectionProps): JSX.Element {
  return (
    <Stack gap={4}>
      <Image
        width={250}
        height={194}
        alt={alt || 'thumbnail image'}
        src={thumbnail || '/test.png'}
        className='w-full h-[194px] object-cover rounded-md'
      />
      <HStack className={cn('items-center gap-2', contentClassName)}>
        {children}
      </HStack>
    </Stack>
  );
}

export function ThumbnailSkeleton(): JSX.Element {
  return (
    <Stack gap={4}>
      <Skeleton className='h-[194px]' />
      <Skeleton className='h-[18px]' />
    </Stack>
  );
}
